import { multipleSelectionSelected } from 'owa-locstrings/lib/strings/multipleselectionselected.locstring.json';
import { filterByAriaLabel, sortByAriaLabel } from './listFilterUtils.locstring.json';
import loc, { format } from 'owa-localize';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';

import { ControlIcons } from 'owa-control-icons';

const checkMarkIcon = { iconName: ControlIcons.Accept };

export function createIContextualMenuItem(
    label: string,
    isSelected: boolean,
    onClickFunction: () => void,
    getAriaLabel: (label: string, isSelected: boolean) => string
): IContextualMenuItem {
    return {
        name: label,
        key: label,
        iconProps: isSelected ? checkMarkIcon : {},
        ariaLabel: getAriaLabel(label, isSelected),
        'aria-hidden': 'true',
        onClick: () => {
            onClickFunction();
        },
    };
}

export function getFilterAriaLabel(filterOptionLabel: string, selected: boolean): string {
    const ariaLabel = format(loc(filterByAriaLabel), filterOptionLabel);
    return selected ? format(loc(multipleSelectionSelected), ariaLabel) : ariaLabel;
}

export function getSortByAriaLabel(showByOptionLabel: string, selected: boolean): string {
    const ariaLabel = format(loc(sortByAriaLabel), showByOptionLabel);
    return selected ? format(loc(multipleSelectionSelected), ariaLabel) : ariaLabel;
}
